<template>
	<div class="flash-offers bg-primary" v-if="!offerClosed">
		<div class="relative">
		<div class="container m-auto px-6 py-2">
			<div class="text-white text-center text-xs md:text-base font-semibold h-8">{{body}}</div>
		</div>
		<a href="#" class="absolute top-2 rtl:right-2 ltr:left-2 text-white text-xs md:text-lg z-20"  @click.prevent.stop="closeHeaderOffer()">
			<i class="fas fa-times-circle"></i>
		</a>
		</div>
	</div>
</template>  

<script>
	import axios from 'axios';
	export default {
		name: 'OfferHeader',
		props: {
			sitelocale: {
				type: String,
				required: true
			},
			body:{
				type: String,
				required: true
			}
		},
		data() {
			return {
				offerClosed:false
			}
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		created(){
			var offerClosed = this.offerClosed;
		},
		methods: {
			closeHeaderOffer(){
				this.offerClosed = true;
				$('.offer-exist').removeClass('offer-exist');
				$('.with-flash-sale').removeClass('with-flash-sale');
			}

		},
	};
</script>

<style lang="scss">

</style>





// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Offers/OfferHeader.vue